import {
  AnyAddress,
  IAutoaddressAddress,
  IDisplayItem,
  IDisplaySection,
  ILocation,
  IPreciselyAddress,
} from "@/types";
import { CoordinateLocation } from "@/types/location/CoordinateLocation";
import { GammaAccuracy } from "@/types/location/location-accuracy";
import { AutoAddressGammaPrecision } from "@/services";

export class AddressLocation extends CoordinateLocation {
  declare address: AnyAddress;

  constructor(props: ILocation) {
    super({ ...props, type: props.type || "Address" });
  }

  get title(): string {
    return this.address.address[0];
  }

  get addressLinkRequest(): any {
    return {
      Address: this.address,
    };
  }

  get precisionAccuracy(): GammaAccuracy | undefined {
    switch (this.address.addressProvider) {
      case "Autoaddress":
        return "matchLevel" in this.address
          ? AutoAddressGammaPrecision[this.address.matchLevel]
          : undefined;
      case "Precisely":
      case "Native":
      default:
        return undefined;
    }
  }

  get displaySections(): IDisplaySection[] {
    const displayItems = this.address.address.map(
      (al): IDisplayItem => ({ value: al, type: "String" })
    );
    if (this.address.postcode) {
      displayItems.push({
        name: "Postcode",
        value: this.address.postcode,
        type: "String",
      });
    }

    if (this.address.addressProvider === "Autoaddress") {
      const aaAddress = this.address as IAutoaddressAddress;
      displayItems.push({
        name: "Match Level",
        value: aaAddress.matchLevel,
        type: "String",
      });
      displayItems.push({
        name: "Match Result",
        value: aaAddress.matchResult,
        type: "String",
      });
    }

    if (this.address.addressProvider === "Precisely") {
      displayItems.push({
        name: "Precision",
        value: (this.address as IPreciselyAddress).precisionLevel,
        type: "String",
      });
    }

    return [
      {
        name: "Address",
        type: "Address",
        items: displayItems,
      },
    ].concat(super.displaySections);
  }
}
